module.exports = __webpack_public_path__ + "static/media/videos.88099532.svg";